import React from "react"
import {Input, InputGroup, InputLeftElement} from "@chakra-ui/react"
import {MagnifyingGlassIcon} from "@heroicons/react/24/outline"
import debounce from "debounce"


const onSearchDebounce = debounce((val, onSearch, cb) => {
    onSearch({searchText: val})
        .then(results => {
            cb({results})
        })
}, 200)

type OnSearchProps = {
    searchText: string
}
type SearchInput = {
    placeholder?: string,
    onSearch: (val: OnSearchProps) => Promise<any>,
    cb: ({results}) => void
}

export function SearchInput({placeholder, onSearch, cb}: SearchInput) {

    return <InputGroup>
        <InputLeftElement pointerEvents="none">
            <MagnifyingGlassIcon className="w-4 h-4 text-gray-400"/>
        </InputLeftElement>
        <Input type="search" onChange={e => {
            onSearchDebounce(e.target.value, onSearch, cb)
        }} placeholder={placeholder || "Search"}/>
    </InputGroup>
}